import { useEffect } from "react";
import { GlobalError } from "@/global-error";
import { createFileRoute } from "@tanstack/react-router";
import { NotFound } from "@/not-found";
import { Container } from "@/components/ui/container";
import { Auth } from "@/components/auth/Auth";
import { PATHS, PATH_LABEL_KEYS } from "@/config/paths";
import { useMobile } from "@/providers/mobileProvider";
import { useMobileNavbar } from "@/providers/mobileNavbarProvider";
import { CalendarSettingsFormCard } from "@/components/cards/profile/CalendarSettingsFormCard";
import { useTranslation } from "@/hooks/useTranslation";
import { Heading } from "@/components/ui/heading";

export const Route = createFileRoute("/dashboard/calendarSettings")({
  component: CalendarSettingsPage,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
});

function CalendarSettingsPage() {
  const { isMobile } = useMobile();
  const { setMobileNavbar } = useMobileNavbar();
  const { t } = useTranslation();

  // Set up navbar configuration
  useEffect(() => {
    if (isMobile) {
      setMobileNavbar({
        title: t(PATH_LABEL_KEYS[PATHS.CALENDAR_SETTINGS]),
        showBackButton: true,
      });
    }
  }, [isMobile, setMobileNavbar]);

  return (
    <Container>
      <Auth>
        <div className="col-span-12 space-y-0.5">
          {!isMobile && (
            <Heading level="h1" size="h4" className="tracking-tight">
              {t(PATH_LABEL_KEYS[PATHS.CALENDAR_SETTINGS])}
            </Heading>
          )}
          <p className="text-muted-foreground">{t("pages.calendar_settings.description")}</p>
        </div>

        <CalendarSettingsFormCard />
      </Auth>
    </Container>
  );
}
